// extracted by mini-css-extract-plugin
export default {"pinText":"pinText--mp-fBgv6"};